import { render, staticRenderFns } from "./BorderPicker.vue?vue&type=template&id=43f549c2"
import script from "./BorderPicker.vue?vue&type=script&lang=js"
export * from "./BorderPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports